import React, { useState, useEffect, useRef } from "react";
import "./TakeawayDeliveryModal.css";
import {
// customerSearch,
  customerSearchV2Api,
  filterCutoff,
  getAddress,
  updateAddress,
  createAddress,
  addCustomer,
  // AddedCustomerData,
  createB2CcustomerApi,
} from "config/Services";
import useCustomerInsights, {
  formatInsightCurrency,
  formatInsightCount,
  formatInsightDate,
  InsightSpinner,
} from "../../../../../hooks/useCustomerInsights";
import { convertToLocalTime } from "../../../product/all-products/Middleware/commonUtils";
import { useSnackbar } from "../../../product/hooks/SnackbarProvider";
import moment from "moment";
import { Box, FormControl, Modal, CircularProgress } from "@mui/material";
import { PencilSquareIcon } from "@heroicons/react/24/outline";
import { countryOptions } from "../../../posnavbar/components/addCustomer/data/countries-details";
import NewCountryCodeInput from "../../../product/all-products/CartAddCustomer/NewCountryCodeInput";
import { BootstrapInput } from "../../../posnavbar/components/addCustomer/components/bootStrapInput";
import useGetDevice from "../../../product/hooks/useGetDevice";

/* ── Inline Icons to match CartCustomerDetails design ── */
const AddressPinIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

const PhoneIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.46 2 2 0 0 1 3.57 1.28h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.64a16 16 0 0 0 6.29 6.29l.91-.91a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
  </svg>
);

const UserIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);

const WalletIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-wallet h-4 w-4 text-emerald-500"
    aria-hidden="true"
    style={{ width: "16px", height: "16px", color: "#10B981" }}
  >
    <path d="M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1"></path>
    <path d="M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4"></path>
  </svg>
);

const ClockIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    className="ccd-delivery-slots-clock-icon"
    aria-hidden="true"
  >
    <path d="M16 14v2.2l1.6 1" />
    <path d="M16 2v4" />
    <path d="M21 7.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h3.5" />
    <path d="M3 10h5" />
    <path d="M8 2v4" />
    <circle cx="16" cy="16" r="6" />
  </svg>
);

const EditPenIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-pen h-3.5 w-3.5"
    aria-hidden="true"
    style={{ width: "14px", height: "14px" }}
  >
    <path d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z" />
  </svg>
);

const CancelCrossIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-x h-3.5 w-3.5"
    aria-hidden="true"
    style={{
      width: "14px",
      height: "14px",
      marginRight: "4px",
    }}
  >
    <path d="M18 6 6 18" />
    <path d="m6 6 12 12" />
  </svg>
);

const PlusIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-plus h-3.5 w-3.5"
    aria-hidden="true"
    style={{
      width: "14px",
      height: "14px",
      marginRight: "4px",
    }}
  >
    <path d="M5 12h14" />
    <path d="M12 5v14" />
  </svg>
);

const getRelativeTime = (dateStr) => {
  if (!dateStr) return null;
  const diff = Date.now() - new Date(dateStr).getTime();
  const days = Math.floor(diff / 86400000);
  if (days === 0) return "Today";
  if (days === 1) return "Yesterday";
  if (days < 30) return `${days} days ago`;
  const months = Math.floor(days / 30);
  if (months < 12) return `${months} month${months > 1 ? "s" : ""} ago`;
  return `${Math.floor(months / 12)} year${Math.floor(months / 12) > 1 ? "s" : ""} ago`;
};

const TakeawayDeliveryModal = ({ open, mode, onClose, onConfirm, onSkip }) => {
  const isDelivery = mode === "DELIVERY";
  const isMobile = useGetDevice();

  const [selectedCountry, setSelectedCountry] = useState({ label: "IN (+91)", value: "+91" });
  const [pickupMode, setPickupMode] = useState("instant");
  const [phone, setPhone] = useState("");
  const [name, setName] = useState("");
  const [addressLine1, setAddressLine1] = useState("");
  const [addressLine2, setAddressLine2] = useState("");
  const [landmark, setLandmark] = useState("");
  const [city, setCity] = useState("");
  const [postcode, setPostcode] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("India");
  const [addressType, setAddressType] = useState("HOME");
  const [savedAddresses, setSavedAddresses] = useState([]);
  const [selectedSavedAddressId, setSelectedSavedAddressId] = useState(null);
  const [addressesLoading, setAddressesLoading] = useState(false);
  const [showAddressFields, setShowAddressFields] = useState(false);
  const [otherAddressName, setOtherAddressName] = useState("");
  const [validationErrorMessage, setValidationErrorMessage] = useState({
    phone: "",
    name: "",
    addressLine1: "",
    addressLine2: "",
    landmark: "",
    city: "",
    state: "",
    postcode: "",
    otherAddressName: "",
  });

  const [customerLookupState, setCustomerLookupState] = useState("idle"); // idle | loading | found | not_found
  const [foundCustomer, setFoundCustomer] = useState(null);
  const [customerSelected, setCustomerSelected] = useState(false);
  const { insights, insightsLoading } = useCustomerInsights({
    uidx: foundCustomer?.uidx,
    id: foundCustomer?.id,
  });
  const tilesLoading = customerLookupState === "loading" || insightsLoading;
  const debounceRef = useRef(null);

  const [skipLoading, setSkipLoading] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);

  const [date, setDate] = useState(new Date());
  const [slotList, setSlotList] = useState([]);
  const [slotsLoading, setSlotsLoading] = useState(false);
  const [selectedSlotId, setSelectedSlotId] = useState(null);
  const showSnackbar = useSnackbar();

  const locId = localStorage.getItem("locId");
  const orgId = localStorage.getItem("orgId");

  const isValidMobile =
    selectedCountry?.value === "+91" ? phone?.length === 10 : phone?.length >= 7;

  // Fetch slots from API when the modal opens, so the instant slot id
  // is available even when Instant mode is selected
  useEffect(() => {
    if (!open) {
      return;
    }
    setSlotsLoading(true);

    const initialDate = date;
    const dayStart = moment(initialDate).startOf("day").utc().format("YYYY-MM-DDTHH:mm:ss");
    const dayEnd = moment(initialDate).endOf("day").utc().format("YYYY-MM-DDTHH:mm:ss");
    const instantDate = moment(initialDate).startOf("day").format("YYYY-MM-DDTHH:mm:ss");

    const payload = {
      slotStartTime: dayStart,
      slotEndTime: dayEnd,
      slotIsDeletedList: [false],
      sourceIdList: [orgId],
      sourceLocationIdList: [locId],
      sortByStartTime: "ASCENDING",
      isRequiredInstantDelivery: true,
      instantDeliveryDate: instantDate,
    };

    filterCutoff(payload)
      .then((res) => {
        const resArray = res?.data?.data?.results;
        const slots =
          resArray?.map((item) => ({
            slotId: item?.slot?.slotId,
            startTime: convertToLocalTime(item?.slot?.startTime),
            endTime: convertToLocalTime(item?.slot?.endTime),
            startTimeUtc: item?.slot?.startTime,
            endTimeUtc: item?.slot?.endTime,
            selected: false,
            date: item?.slot?.day,
            cutoffId: item?.cutoffId,
          })) || [];

        // instantDeliveryResults can be an object or an array depending on the backend
        const instantResults = res?.data?.data?.instantDeliveryResults;
        const instantDelivery = Array.isArray(instantResults)
          ? instantResults?.[0]
          : instantResults;
        if (instantDelivery?.instantDeliveryId) {
          // Times may come as "HH:mm:ss" only — combine with instantDeliveryDate
          const toDateTime = (time) =>
            time && !time.includes("T") && instantDelivery?.instantDeliveryDate
              ? `${instantDelivery?.instantDeliveryDate}T${time}`
              : time;
          const startUtc = toDateTime(instantDelivery?.instantDeliveryStartTime);
          const endUtc = toDateTime(instantDelivery?.instantDeliveryEndTime);
          const item = {
            slotId: instantDelivery?.instantDeliveryId,
            startTime: convertToLocalTime(startUtc),
            endTime: convertToLocalTime(endUtc),
            startTimeUtc: startUtc,
            endTimeUtc: endUtc,
            active: instantDelivery?.active,
            selected: false,
            instant: true,
          };
          slots?.unshift(item);
        }

        if (
          res?.data?.status === "ERROR" ||
          res?.data?.data?.status === "ERROR" ||
          res?.data?.data?.es > 0
        ) {
          showSnackbar(res?.data?.data?.message || "Error while Fetching slots", "error");
          setSlotsLoading(false);
          return;
        }

        setSlotList(slots);
        setSlotsLoading(false);
      })
      .catch((err) => {
        showSnackbar(
          err?.message || (typeof err === "string" ? err : "Unable to Fetch Slots"),
          "error"
        );
        setSlotsLoading(false);
      });
  }, [date, orgId, locId, open]);

  const generateDateChips = () => {
    const today = new Date();
    const options = { weekday: "short", day: "numeric", month: "short" };
    const chips = [];

    for (let i = 0; i < 10; i++) {
      const chipDate = new Date(today);
      chipDate.setDate(today.getDate() + i);

      let label;
      if (i === 0) {
        label = "Today";
      } else if (i === 1) {
        label = "Tomorrow";
      } else {
        label = chipDate.toLocaleDateString("en-US", options);
      }
      chips.push({ date: label, actualDate: chipDate });
    }
    return chips;
  };

  const dateChips = generateDateChips();

  const handleDate = (chipDate) => {
    setDate(chipDate);
    setSelectedSlotId(null);
  };

  const isToday =
    date.getFullYear() === new Date().getFullYear() &&
    date.getMonth() === new Date().getMonth() &&
    date.getDate() === new Date().getDate();

  const currentUtcTime = moment.utc();
  const filteredSlots = isToday
    ? slotList?.filter((slot) => moment.utc(slot?.endTimeUtc).isAfter(currentUtcTime))
    : slotList;

  const [editingAddressId, setEditingAddressId] = useState(null);
  const [updateLoading, setUpdateLoading] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);
  const [deliveryCharges, setDeliveryCharges] = useState("");
  const [packingCharges, setPackingCharges] = useState("");

  const handleChargeInput = (value, setter) => {
    const charges = value === "." ? "0." : value;
    if (/^\d*\.?\d{0,2}$/.test(charges)) setter(charges);
  };

  const fetchSavedAddresses = (cid = foundCustomer?.id) => {
    if (!cid) return;
    setAddressesLoading(true);
    getAddress(cid)
      .then((res) => {
        const addresses = res?.data?.addresses || [];
        setSavedAddresses(addresses);
        const hasHome = addresses?.some((addr) => addr?.addressType === "HOME");
        const hasWork = addresses?.some((addr) => addr?.addressType === "WORK");
        if (hasHome && hasWork) {
          setAddressType("OTHER");
        } else if (hasHome) {
          setAddressType("WORK");
        } else {
          setAddressType("HOME");
        }
        if (selectedSavedAddressId) {
          const matched = addresses?.find(
            (addr) => String(addr?.addressId) === String(selectedSavedAddressId)
          );
          if (matched) {
            setSelectedSavedAddressId(matched?.addressId);
          }
        }
      })
      .catch(() => {
        setSavedAddresses([]);
      })
      .finally(() => {
        setAddressesLoading(false);
      });
  };

  // Automatically fetch saved addresses when customer is found
  useEffect(() => {
    if (isDelivery && foundCustomer?.id) {
      setCustomerSelected(true);
      fetchSavedAddresses(foundCustomer?.id);
    } else {
      setSavedAddresses([]);
      setSelectedSavedAddressId(null);
      setShowAddressFields(false);
    }
  }, [isDelivery, foundCustomer?.id]);

  const handleEditAddressClick = (e, addr) => {
    e.stopPropagation();
    setEditingAddressId(addr?.addressId);
    setShowAddressFields(true);
    setSelectedSavedAddressId(null);

    const type = ["HOME", "WORK", "OTHER"].includes(addr?.addressType)
      ? addr?.addressType
      : "OTHER";

    setAddressType(type);
    setOtherAddressName(type === "OTHER" ? addr?.otherName || addr?.addressType || "" : "");
    setAddressLine1(addr?.addressLine1 || "");
    setAddressLine2(addr?.addressLine2 || "");
    setLandmark(addr?.landmark || "");
    setCity(addr?.city || "");
    setState(addr?.state || "");
    setPostcode(addr?.pincode || "");
    setCountry(addr?.country || "India");
  };

  const handleCancelEdit = () => {
    setEditingAddressId(null);
    setShowAddressFields(false);
    setAddressType("HOME");
    setOtherAddressName("");
    setAddressLine1("");
    setAddressLine2("");
    setLandmark("");
    setCity("");
    setState("");
    setPostcode("");
    setCountry("India");
    setValidationErrorMessage((prev) => ({
      ...prev,
      addressLine1: "",
      addressLine2: "",
      landmark: "",
      city: "",
      state: "",
      postcode: "",
      otherAddressName: "",
    }));
  };

  const isAddressFormValid = () => {
    return !!(
      addressLine1 &&
      addressLine2 &&
      landmark &&
      city &&
      state &&
      /^\d{6}$/.test(postcode) &&
      (addressType !== "OTHER" || otherAddressName?.trim())
    );
  };

  const validateAddressForm = () => {
    const errs = {};
    if (addressType === "OTHER" && (!otherAddressName || !otherAddressName?.trim())) {
      errs.otherAddressName = "Required";
    }
    if (!addressLine1) errs.addressLine1 = "Required";
    if (!addressLine2) errs.addressLine2 = "Required";
    if (!landmark) errs.landmark = "Required";
    if (!city) errs.city = "Required";
    if (!state) errs.state = "Required";
    if (!postcode || !/^\d{6}$/.test(postcode)) errs.postcode = "6 digits required";
    setValidationErrorMessage((prev) => ({ ...prev, ...errs }));
    return Object.keys(errs).length === 0;
  };

  const handleSaveAddress = () => {
    // 1. Validate phone number and name
    let errors = {
      phone: "",
      name: "",
      addressLine1: "",
      addressLine2: "",
      landmark: "",
      city: "",
      state: "",
      postcode: "",
      otherAddressName: "",
    };

    if (!isValidMobile) {
      errors.phone = "Please enter a valid phone number";
      setValidationErrorMessage(errors);
      return;
    }


    // 2. Validate address form
    if (!validateAddressForm()) return;

    setSaveLoading(true);

    const user_name = localStorage.getItem("user_name");
    const retailUserLocalStorageData = JSON.parse(
      localStorage.getItem("retailUserDetails") || "{}"
    );
    const sessionId = localStorage.getItem("sessionId");

    const saveAddressWithCustomerId = (cid) => {
      const addrPayload = {
        customerId: cid,
        addressLine1: addressLine1,
        addressLine2: addressLine2,
        city: city,
        state: state,
        country: country || "India",
        pincode: postcode,
        addressType: addressType,
        phoneNumber: phone,
        landmark: landmark,
        defaultShipping: true,
        defaultBilling: true,
        latitude: 0,
        longitude: 0,
        createdBy: user_name,
        ...(addressType === "OTHER" && {
          otherName: otherAddressName,
        }),
      };

      createAddress(addrPayload)
        .then((res) => {
          if (
            res?.data?.status === "ERROR" ||
            res?.data?.status === "error" ||
            res?.data?.data?.es > 0 ||
            res?.data?.es > 0 ||
            res?.data?.data?.status === "ERROR" ||
            res?.data?.data?.status === "error"
          ) {
            showSnackbar(
              res?.data?.data?.message || res?.data?.message || "Unable to save address",
              "error"
            );
            return;
          }

          showSnackbar("Address saved successfully", "success");
          const newAddr = res?.data?.address || res?.data?.data?.address;

          setShowAddressFields(false);

          if (newAddr) {
            setSelectedSavedAddressId(newAddr.addressId);
          }

          // Refetch saved addresses
          fetchSavedAddresses(cid);
        })
        .catch((err) => {
          showSnackbar(
            err?.response?.data?.message || err?.message || "Unable to save address",
            "error"
          );
        })
        .finally(() => {
          setSaveLoading(false);
        });
    };

    if (foundCustomer) {
      // Existing customer
      saveAddressWithCustomerId(foundCustomer?.id || foundCustomer?.uidx);
    } else {
      // New customer: create customer first
      const removePlusSignLocal = (input) => {
        if (typeof input !== "string") return input;
        return input.startsWith("+") ? input.slice(1) : input;
      };

      const addCustomerPayload = {
        mobile: phone,
        firstName: name || "",
        countryCode: removePlusSignLocal(selectedCountry?.value || "91"),
        tenantId: locId,
      };

      addCustomer(addCustomerPayload)
        .then((response) => {
          const uidx = response?.data?.data?.uidx;
          if (!uidx) {
            showSnackbar("Failed to create customer record", "error");
            setSaveLoading(false);
            return;
          }

          const customerUidxData = {
            uidx: uidx,
            phoneNumber: phone,
            name: response?.data?.data?.firstName || name,
            organizationId: orgId,
            createdBy: retailUserLocalStorageData?.uidx,
            locationId: locId,
            sessionId: sessionId,
            platform: "POS"
          };

          /*
          AddedCustomerData(customerUidxData)
            .then((resp) => {
              const storeCustId = resp?.data?.retailCustomer?.id || uidx;
          */
          createB2CcustomerApi(customerUidxData)
            .then((resp) => {
              const storeCustId = resp?.data?.customer?.id || uidx;
              localStorage.setItem("customerId", storeCustId);

              // Set state to reflect that the customer is now found and selected
              const newCustomerObj = {
                id: storeCustId,
                uidx: uidx,
                firstName: response?.data?.data?.firstName || name,
                mobile: phone,
                created: response?.data?.data?.created,
              };
              setFoundCustomer(newCustomerObj);
              setCustomerLookupState("found");
              setCustomerSelected(true);

              // Proceed to save address
              saveAddressWithCustomerId(storeCustId);
            })
            .catch((err) => {
              showSnackbar(err?.message || "Failed to link customer", "error");
              setSaveLoading(false);
            });
        })
        .catch((err) => {
          showSnackbar(err?.message || "Failed to create customer", "error");
          setSaveLoading(false);
        });
    }
  };

  const handleUpdateAddressClick = () => {
    if (!validateAddressForm()) return;

    const user_name = localStorage.getItem("user_name");
    const addrPayload = {
      customerId: foundCustomer?.id,
      addressId: String(editingAddressId),
      addressLine1: addressLine1,
      addressLine2: addressLine2,
      city: city,
      state: state,
      country: country,
      pincode: postcode,
      addressType: addressType,
      landmark: landmark,
      defaultShipping: true,
      defaultBilling: true,
      latitude: 0,
      longitude: 0,
      updatedBy: user_name,
      ...(addressType === "OTHER" && {
        otherName: otherAddressName,
      }),
    };

    setUpdateLoading(true);
    updateAddress(addrPayload)
      .then((res) => {
        if (
          res?.data?.status === "ERROR" ||
          res?.data?.status === "error" ||
          res?.data?.data?.es > 0 ||
          res?.data?.es > 0 ||
          res?.data?.data?.status === "ERROR" ||
          res?.data?.data?.status === "error"
        ) {
          showSnackbar(
            res?.data?.data?.message || res?.data?.message || "Unable to update delivery address",
            "error"
          );
          setUpdateLoading(false);
          return;
        }

        showSnackbar("Address updated successfully", "success");
        setEditingAddressId(null);
        setShowAddressFields(false);
        // Refetch saved addresses
        fetchSavedAddresses(foundCustomer?.id);
      })
      .catch((err) => {
        showSnackbar(
          err?.response?.data?.message || err?.message || "Unable to update delivery address",
          "error"
        );
      })
      .finally(() => {
        setUpdateLoading(false);
      });
  };

  // Reset on open
  useEffect(() => {
    if (open) {
      setPickupMode("instant");
      setPhone("");
      setName("");
      setAddressLine1("");
      setAddressLine2("");
      setLandmark("");
      setCity("");
      setPostcode("");
      setState("");
      setCountry("India");
      setAddressType("HOME");
      setSavedAddresses([]);
      setSelectedSavedAddressId(null);
      setAddressesLoading(false);
      setShowAddressFields(false);
      setOtherAddressName("");
      setCustomerLookupState("idle");
      setFoundCustomer(null);
      setCustomerSelected(false);
      setDate(new Date());
      setSlotList([]);
      setSelectedSlotId(null);
      setEditingAddressId(null);
      setUpdateLoading(false);
      setSkipLoading(false);
      setConfirmLoading(false);
      setDeliveryCharges("");
      setPackingCharges("");
      setSelectedCountry({ label: "IN (+91)", value: "+91" });
      setValidationErrorMessage({
        phone: "",
        name: "",
        addressLine1: "",
        addressLine2: "",
        landmark: "",
        city: "",
        state: "",
        postcode: "",
        otherAddressName: "",
      });
    }
  }, [open]);

  // Debounced phone lookup
  useEffect(() => {
    if (debounceRef.current) clearTimeout(debounceRef.current);
    if (customerSelected) return;

    if (!isValidMobile) {
      setCustomerLookupState("idle");
      setFoundCustomer(null);
      return;
    }

    setCustomerLookupState("loading");
    setFoundCustomer(null);

    debounceRef.current = setTimeout(() => {
      const orgId = localStorage.getItem("orgId");
      /*
      customerSearch({ orgId, pageNo: 0, pageSize: 1, mobile: phone })
      */
      customerSearchV2Api({ organizationId: orgId, search: phone, pageNumber: 0, pageSize: 1 })
        .then((res) => {
          const found = res?.data?.customers?.[0];
          if (!found) {
            setCustomerLookupState("not_found");
            setName("");
            return;
          }
          setFoundCustomer(found);
          setCustomerLookupState("found");

          const fullName =
            `${found?.firstName || ""}${found?.lastName ? " " + found?.lastName : ""}`.trim() ||
            found?.name ||
            "";
          setName(fullName);
        })
        .catch(() => {
          setCustomerLookupState("not_found");
          setName("");
        });
    }, 500);
  }, [phone, selectedCountry]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleSelectCustomer = () => {
    if (foundCustomer) {
      const fullName =
        `${foundCustomer?.firstName || ""}${
          foundCustomer?.lastName ? " " + foundCustomer?.lastName : ""
        }`.trim() ||
        foundCustomer?.name ||
        "";
      setName(fullName);
      setCustomerSelected(true);
      setValidationErrorMessage((prev) => ({ ...prev, name: "", phone: "" }));

      if (isDelivery && foundCustomer?.id) {
        setAddressesLoading(true);
        getAddress(foundCustomer?.id)
          .then((res) => {
            if (res?.data?.addresses) {
              setSavedAddresses(res?.data?.addresses);
              const hasHome = res?.data?.addresses?.some((addr) => addr?.addressType === "HOME");
              const hasWork = res?.data?.addresses?.some((addr) => addr?.addressType === "WORK");
              if (hasHome && hasWork) {
                setAddressType("OTHER");
              } else if (hasHome) {
                setAddressType("WORK");
              } else {
                setAddressType("HOME");
              }
            }
          })
          .catch(() => {})
          .finally(() => {
            setAddressesLoading(false);
          });
      }
    }
  };

  const handlePhoneChange = (val) => {
    const digits = val.replace(/\D/g, "");
    setPhone(digits);
    setCustomerSelected(false);
    setSavedAddresses([]);
    setSelectedSavedAddressId(null);
    setShowAddressFields(false);
    setValidationErrorMessage((prev) => ({ ...prev, phone: "" }));
  };

  const handleSelectSavedAddress = (addr) => {
    setSelectedSavedAddressId(addr?.addressId);
    setShowAddressFields(false);
    setAddressType(addr?.addressType || "HOME");
    setAddressLine1(addr?.addressLine1 || "");
    setAddressLine2(addr?.addressLine2 || "");
    setLandmark(addr?.landmark || "");
    setCity(addr?.city || "");
    setPostcode(addr?.pincode || "");
    setState(addr?.state || "");
    setCountry(addr?.country || "India");
    setOtherAddressName(addr?.otherName || "");
    setValidationErrorMessage((prev) => ({
      ...prev,
      addressLine1: "",
      addressLine2: "",
      landmark: "",
      city: "",
      state: "",
      postcode: "",
      otherAddressName: "",
    }));
  };

  const handleConfirm = () => {
    let errors = {
      phone: "",
      name: "",
      addressLine1: "",
      addressLine2: "",
      landmark: "",
      city: "",
      state: "",
      postcode: "",
      otherAddressName: "",
    };

    if (!isValidMobile) {
      errors.phone = "Please enter a valid phone number";
      setValidationErrorMessage(errors);
      return;
    }


    if (
      isDelivery &&
      savedAddresses &&
      savedAddresses?.length > 0 &&
      !selectedSavedAddressId &&
      !showAddressFields
    ) {
      showSnackbar("Please select an address or Add Address", "warning");
      return;
    }

    if (isDelivery && !selectedSavedAddressId) {
      if (addressType === "OTHER" && (!otherAddressName || !otherAddressName.trim())) {
        errors.otherAddressName = "Address name is required for Other address type";
        setValidationErrorMessage(errors);
        return;
      }
      if (!addressLine1 || !addressLine1.trim()) {
        errors.addressLine1 = "First line of address is required";
        setValidationErrorMessage(errors);
        return;
      }
      if (!addressLine2 || !addressLine2.trim()) {
        errors.addressLine2 = "Second line of address is required";
        setValidationErrorMessage(errors);
        return;
      }
      if (!landmark || !landmark.trim()) {
        errors.landmark = "Nearby landmark is required";
        setValidationErrorMessage(errors);
        return;
      }
      if (!city || !city.trim()) {
        errors.city = "City is required";
        setValidationErrorMessage(errors);
        return;
      }
      if (!state || !state.trim()) {
        errors.state = "State is required";
        setValidationErrorMessage(errors);
        return;
      }
      if (!postcode || !postcode.trim()) {
        errors.postcode = "Postcode is required";
        setValidationErrorMessage(errors);
        return;
      } else if (!/^\d{6}$/.test(postcode)) {
        errors.postcode = "Postcode must be 6 digits";
        setValidationErrorMessage(errors);
        return;
      }
    }

    setValidationErrorMessage(errors);

    if (pickupMode === "slot" && !selectedSlotId) {
      showSnackbar("Please select a slot before confirming", "warning");
      return;
    }

    const selectedSlot =
      pickupMode === "instant"
        ? slotList?.find((slot) => slot?.instant)
        : slotList?.find((slot) => slot?.slotId === selectedSlotId);

    const customerData = {
      phone: phone.trim(),
      name: name.trim(),
      ...(foundCustomer ? { uidx: foundCustomer?.uidx, id: foundCustomer?.id } : {}),
      ...(isDelivery
        ? {
            address: {
              addressId: selectedSavedAddressId,
              type: addressType,
              addressType: addressType,
              line1: addressLine1?.trim(),
              line2: addressLine2?.trim(),
              landmark: landmark?.trim(),
              city: city?.trim(),
              postcode: postcode?.trim(),
              state: state?.trim(),
              country: country?.trim(),
              ...(addressType === "OTHER" && { otherName: otherAddressName?.trim() }),
            },
            deliveryCharges: deliveryCharges ? Number(deliveryCharges) : 0,
            packingCharges: packingCharges ? Number(packingCharges) : 0,
          }
        : {
            packingCharges: packingCharges ? Number(packingCharges) : 0,
          }),
      ...(selectedSlot
        ? {
            slotDetails: {
              slotId: selectedSlot?.slotId || "",
              startTime: selectedSlot?.startTimeUtc || "",
              endTime: selectedSlot?.endTimeUtc || "",
              cutoffId: selectedSlot?.cutoffId || "",
            },
          }
        : {}),
    };
    setConfirmLoading(true);
    Promise.resolve(onConfirm(customerData)).finally(() => setConfirmLoading(false));
  };

  const handleSkip = () => {
    if (skipLoading || confirmLoading) return;
    setSkipLoading(true);
    Promise.resolve(onSkip()).finally(() => setSkipLoading(false));
  };

  const isAddressEnabled =
    (customerLookupState === "not_found" && isValidMobile) || customerSelected;

  const hasSavedHome = savedAddresses?.some((addr) => addr?.addressType === "HOME");
  const hasSavedWork = savedAddresses?.some((addr) => addr?.addressType === "WORK");

  const isAddressFormActive = isDelivery && (savedAddresses?.length === 0 || showAddressFields);

  const isConfirmButtonVisuallyDisabled =
    isDelivery &&
    (isAddressFormActive ||
      (savedAddresses && savedAddresses?.length > 0 && !selectedSavedAddressId));

  const handleKeyPress = (e) => {
    if (e.key !== "Enter") return;
    e.preventDefault();
    if (skipLoading || confirmLoading) return;
    if (!phone.trim()) {
      handleSkip();
    }
  };

  const handleCountryChange = (selectedOption) => {
    setSelectedCountry(selectedOption);
  };

  if (!open) return null;

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "fixed",
          top: 0,
          right: 0,
          height: "100%",
          width: isMobile ? "100%" : "min(980px, 100vw)",
          bgcolor: "#fff",
          borderRadius: 0,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          boxShadow: "0 40px 120px rgba(15,23,42,0.28)",
          borderLeft: "1px solid rgba(255, 255, 255, 0.7)",
          animation: "ccdSlideIn 0.25s ease",
          transition: "width 0.25s ease",
        }}
      >
        {/* ── HEADER ── */}
        <div className="ccd-header-ref">
          <h2 className="ccd-title-ref" data-testid="text-customer-popup-title">
            {isDelivery ? "Delivery details" : "Takeaway details"}
          </h2>
          <button
            className="ccd-close-btn-ref"
            onClick={onClose}
            data-testid="button-customer-modal-close"
          >
            <CancelCrossIcon />
          </button>
        </div>

        {/* ── SPLIT GRID LAYOUT ── */}
        <div className="ccd-split-grid">
          {/* ── FORM SIDE (Left Column) ── */}
          <div className="ccd-form-side-ref">
            <div className="ccd-form-content-ref">
              <div className="ccd-form-scrollable-ref">
                {/* Mobile + Name — side by side */}
                <div className="ccd-inputs-grid-ref">
                  <div>
                    <label className="ccd-input-label-ref">Mobile number</label>
                    <div className="ccd-mobile-input-row-ref">
                      <FormControl variant="standard" sx={{ width: "100%" }}>
                        <NewCountryCodeInput
                          countryOptions={countryOptions}
                          customerMobileNumber={phone}
                          setCustomerMobileNumber={handlePhoneChange}
                          handleKeyPress={handleKeyPress}
                          selectedCountry={selectedCountry}
                          handleCountryChange={handleCountryChange}
                        />
                      </FormControl>
                    </div>
                  </div>
                  <div>
                    <label className="ccd-input-label-ref">Customer name</label>
                    <FormControl variant="standard" sx={{ width: "100%" }}>
                      <div
                        style={{
                          position: "relative",
                          width: "100%",
                          display: "flex",
                          alignItems: "center",
                          height: "48px",
                        }}
                      >
                        <BootstrapInput
                          sx={{
                            width: "100%",
                            "& .MuiInputBase-input": {
                              backgroundColor: "#ffffff",
                              border: "1px solid #e2e8f0",
                              borderRadius: "20px",
                              boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05) !important",
                              fontSize: "0.875rem !important",
                              fontWeight: "500 !important",
                              color: "#333333 !important",
                              padding:
                                customerLookupState === "loading"
                                  ? "12px 40px 12px 16px !important"
                                  : "12px 16px !important",
                              height: "48px !important",
                              boxSizing: "border-box !important",
                              "&::placeholder": {
                                color: "#65758B !important",
                                opacity: 1,
                                fontSize: "0.875rem !important",
                                fontWeight: "400 !important",
                              },
                              "&.Mui-disabled": {
                                backgroundColor: "#f1f5f9 !important",
                                color: "#94a3b8 !important",
                                WebkitTextFillColor: "#94a3b8 !important",
                                cursor: "not-allowed !important",
                              },
                            },
                          }}
                          className="customer-name-new"
                          placeholder="Enter customer name"
                          id="bootstrap-input"
                          value={name}
                          onChange={(e) => {
                            setName(e.target.value);
                            setValidationErrorMessage((prev) => ({ ...prev, name: "" }));
                          }}
                          onKeyDown={handleKeyPress}
                          disabled={!phone}
                        />
                        {customerLookupState === "loading" && (
                          <CircularProgress
                            size={18}
                            sx={{
                              position: "absolute",
                              right: "16px",
                              top: "30%",
                              transform: "translateY(-50%)",
                              color: "#2a71ff",
                              zIndex: 10,
                            }}
                          />
                        )}
                      </div>
                    </FormControl>
                  </div>
                </div>

                {/* ── Slot Picker / Delivery Section ── */}
                {isValidMobile && (
                  <div className="ccd-delivery-section">
                    {!showAddressFields && (
                      <>
                        <p className="ccd-delivery-section-label">
                          {isDelivery ? "DELIVERY MODE" : "PICKUP MODE"}
                        </p>
                        <p className="ccd-delivery-section-desc">
                          {isDelivery
                            ? "Choose how this order should be dispatched."
                            : "Choose when the guest wants to collect the order."}
                        </p>
                        <div className="ccd-delivery-mode-options">
                          <div
                            className={`ccd-delivery-mode-option${
                              pickupMode === "instant" ? " active" : ""
                            }`}
                            onClick={() => setPickupMode("instant")}
                          >
                            <div className="ccd-delivery-mode-option-text">
                              <span className="ccd-delivery-mode-option-title">
                                {isDelivery ? "Instant delivery" : "Instant pickup"}
                              </span>
                              <span className="ccd-delivery-mode-option-desc">
                                {isDelivery
                                  ? "Dispatch as soon as the kitchen starts."
                                  : "Pickup starts as soon as the order is ready."}
                              </span>
                            </div>
                            <div
                              className={`ccd-delivery-radio${
                                pickupMode === "instant" ? " active" : ""
                              }`}
                            />
                          </div>
                          <div
                            className={`ccd-delivery-mode-option${
                              pickupMode === "slot" ? " active" : ""
                            }`}
                            onClick={() => setPickupMode("slot")}
                          >
                            <div className="ccd-delivery-mode-option-text">
                              <span className="ccd-delivery-mode-option-title">Choose a slot</span>
                              <span className="ccd-delivery-mode-option-desc">
                                {isDelivery
                                  ? "Reserve a specific delivery window."
                                  : "Reserve a pickup time window."}
                              </span>
                            </div>
                            <div
                              className={`ccd-delivery-radio${
                                pickupMode === "slot" ? " active" : ""
                              }`}
                            />
                          </div>
                        </div>

                        {pickupMode === "slot" && (
                          <div className="ccd-delivery-slots-container">
                            <div className="ccd-delivery-slots-header">
                              <ClockIcon />
                              {isDelivery
                                ? "Select delivery date & time"
                                : "Select pickup date & time"}
                            </div>

                            {/* Date Chips */}
                            <div className="ccd-delivery-date-chips-container">
                              {dateChips?.length > 0 ? (
                                dateChips?.map((item) => (
                                  <button
                                    key={item?.date}
                                    type="button"
                                    className={`ccd-delivery-date-chip-btn${
                                      date.toDateString() === item?.actualDate?.toDateString()
                                        ? " ccd-delivery-date-chip-btn--selected"
                                        : ""
                                    }`}
                                    onClick={() => handleDate(item?.actualDate)}
                                  >
                                    {item?.date}
                                  </button>
                                ))
                              ) : (
                                <p className="ccd-delivery-slots-empty">No Dates Found</p>
                              )}
                            </div>

                            {/* Slots List / Loading */}
                            {slotsLoading ? (
                              <div className="ccd-delivery-slots-loader">
                                <span className="ccd-delivery-slots-spinner" />
                              </div>
                            ) : (
                              <div className="ccd-delivery-slots-grid">
                                {filteredSlots?.length > 0 ? (
                                  filteredSlots?.map((slot) => {
                                    const isSelected = selectedSlotId === slot?.slotId;
                                    return (
                                      <button
                                        key={slot?.slotId}
                                        type="button"
                                        className={
                                          isSelected
                                            ? "ccd-delivery-slot-btn--selected"
                                            : "ccd-delivery-slot-btn--unselected"
                                        }
                                        onClick={() => setSelectedSlotId(slot?.slotId)}
                                      >
                                        {slot?.instant
                                          ? "Now"
                                          : `${slot?.startTime} - ${slot?.endTime}`}
                                      </button>
                                    );
                                  })
                                ) : (
                                  <p className="ccd-delivery-slots-empty">No Slots Found</p>
                                )}
                              </div>
                            )}
                          </div>
                        )}
                      </>
                    )}

                    {/* ── Address container section ── */}
                    {isDelivery && (
                      <>
                        <div className="ccd-delivery-address-header">
                          <div className="ccd-delivery-address-header-inner">
                            <AddressPinIcon />
                            Delivery address
                          </div>
                        </div>

                        <div className="ccd-section ccd-address-section">
                          {/* Saved Addresses */}
                          {addressesLoading ? (
                            <div className="ccd-addr-loader">Fetching saved addresses…</div>
                          ) : (
                            savedAddresses?.length > 0 && (
                              <div className="ccd-saved-addresses-section">
                                <div className="ccd-saved-addresses-header">
                                  <label className="ccd-saved-addresses-title">
                                    SAVED ADDRESSES
                                  </label>
                                  {!showAddressFields && (
                                    <button
                                      type="button"
                                      className="ccd-add-address-link"
                                      onClick={() => {
                                        setEditingAddressId(null);
                                        setShowAddressFields(true);
                                        setSelectedSavedAddressId(null);
                                        const hasHome = savedAddresses?.some(
                                          (addr) => addr?.addressType === "HOME"
                                        );
                                        const hasWork = savedAddresses?.some(
                                          (addr) => addr?.addressType === "WORK"
                                        );
                                        if (hasHome && hasWork) {
                                          setAddressType("OTHER");
                                        } else if (hasHome) {
                                          setAddressType("WORK");
                                        } else {
                                          setAddressType("HOME");
                                        }
                                        setAddressLine1("");
                                        setAddressLine2("");
                                        setLandmark("");
                                        setCity("");
                                        setPostcode("");
                                        setState("");
                                        setCountry("India");
                                      }}
                                      disabled={!isAddressEnabled}
                                    >
                                      <PlusIcon />
                                      Add Address
                                    </button>
                                  )}
                                </div>
                                <div className="ccd-saved-addresses-grid">
                                  {savedAddresses
                                    ?.filter(
                                      (addr) =>
                                        !editingAddressId || addr?.addressId === editingAddressId
                                    )
                                    ?.map((addr) => {
                                      const isSelected = selectedSavedAddressId === addr?.addressId;
                                      const addrLabel =
                                        addr?.addressType === "OTHER"
                                          ? addr?.otherName || "Other"
                                          : addr?.addressType === "HOME"
                                          ? "Home"
                                          : addr?.addressType === "WORK"
                                          ? "Work"
                                          : "Address";
                                      return (
                                        <div
                                          key={addr?.addressId}
                                          className={`ccd-saved-address-card${
                                            isSelected ? " active" : ""
                                          }`}
                                          onClick={() =>
                                            isAddressEnabled && handleSelectSavedAddress(addr)
                                          }
                                        >
                                          <div className="ccd-saved-address-card-header">
                                            <span className="ccd-saved-address-type-label">
                                              {addrLabel}
                                            </span>
                                            <button
                                              type="button"
                                              onClick={(e) =>
                                                isAddressEnabled && handleEditAddressClick(e, addr)
                                              }
                                              className="ccd-edit-address-pen-btn"
                                            >
                                              <EditPenIcon />
                                            </button>
                                          </div>
                                          <p className="ccd-saved-address-description">
                                            {addr?.addressLine1}
                                            {addr?.addressLine2 ? `, ${addr?.addressLine2}` : ""}
                                            {addr?.landmark ? `, Near ${addr?.landmark}` : ""}
                                            {addr?.city ? `, ${addr?.city}` : ""}
                                            {addr?.pincode ? ` - ${addr?.pincode}` : ""}
                                          </p>
                                        </div>
                                      );
                                    })}
                                </div>
                              </div>
                            )
                          )}

                          {/* Address Form (if empty or showAddressFields is true) */}
                          {(savedAddresses?.length === 0 || showAddressFields) && (
                            <>
                              <div className="ccd-addr-form">
                                {/* Address Type options */}
                                <div className="ccd-addr-type-options">
                                  {["HOME", "WORK", "OTHER"].map((t) => {
                                    const isDisabled =
                                      (t === "HOME" && hasSavedHome) ||
                                      (t === "WORK" && hasSavedWork);
                                    return (
                                      <div
                                        key={t}
                                        className={`ccd-addr-type-option${
                                          addressType === t ? " active" : ""
                                        }${isDisabled ? " disabled" : ""}`}
                                        onClick={() => {
                                          if (!isDisabled && isAddressEnabled) {
                                            setAddressType(t);
                                            setSelectedSavedAddressId(null);
                                          }
                                        }}
                                      >
                                        <span className="ccd-addr-type-label-text">
                                          {t === "HOME" ? "Home" : t === "WORK" ? "Work" : "Others"}
                                        </span>
                                        <div
                                          className={`ccd-addr-radio${
                                            addressType === t ? " active" : ""
                                          }${isDisabled ? " disabled" : ""}`}
                                        />
                                      </div>
                                    );
                                  })}
                                </div>

                                {addressType === "OTHER" && (
                                  <div className="ccd-addr-input-group ccd-addr-input-group--full">
                                    <label className="ccd-addr-input-label">Address Name</label>
                                    <div className="ccd-addr-input-wrap">
                                      <input
                                        className="ccd-addr-input ccd-addr-input--no-icon"
                                        placeholder="e.g. Friend's House, Parent's Home"
                                        value={otherAddressName}
                                        onChange={(e) => {
                                          setOtherAddressName(e.target.value);
                                          setSelectedSavedAddressId(null);
                                          setValidationErrorMessage((prev) => ({
                                            ...prev,
                                            otherAddressName: "",
                                          }));
                                        }}
                                        disabled={!isAddressEnabled}
                                      />
                                    </div>
                                    {validationErrorMessage?.otherAddressName && (
                                      <span className="ccd-addr-error">
                                        {validationErrorMessage?.otherAddressName}
                                      </span>
                                    )}
                                  </div>
                                )}

                                <div className="ccd-addr-input-group ccd-addr-input-group--full">
                                  <label className="ccd-addr-input-label">First line</label>
                                  <div className="ccd-addr-input-wrap">
                                    <AddressPinIcon />
                                    <input
                                      className="ccd-addr-input"
                                      placeholder="Flat / building / house number"
                                      value={addressLine1}
                                      onChange={(e) => {
                                        setAddressLine1(e.target.value);
                                        setSelectedSavedAddressId(null);
                                        setValidationErrorMessage((prev) => ({
                                          ...prev,
                                          addressLine1: "",
                                        }));
                                      }}
                                      disabled={!isAddressEnabled}
                                    />
                                  </div>
                                  {validationErrorMessage?.addressLine1 && (
                                    <span className="ccd-addr-error">
                                      {validationErrorMessage?.addressLine1}
                                    </span>
                                  )}
                                </div>

                                <div className="ccd-addr-input-group ccd-addr-input-group--full">
                                  <label className="ccd-addr-input-label">Second line</label>
                                  <div className="ccd-addr-input-wrap">
                                    <input
                                      className="ccd-addr-input ccd-addr-input--no-icon"
                                      placeholder="Street, area"
                                      value={addressLine2}
                                      onChange={(e) => {
                                        setAddressLine2(e.target.value);
                                        setSelectedSavedAddressId(null);
                                        setValidationErrorMessage((prev) => ({
                                          ...prev,
                                          addressLine2: "",
                                        }));
                                      }}
                                      disabled={!isAddressEnabled}
                                    />
                                  </div>
                                  {validationErrorMessage?.addressLine2 && (
                                    <span className="ccd-addr-error">
                                      {validationErrorMessage?.addressLine2}
                                    </span>
                                  )}
                                </div>

                                <div className="ccd-addr-input-group ccd-addr-input-group--full">
                                  <label className="ccd-addr-input-label">Nearby landmark</label>
                                  <div className="ccd-addr-input-wrap">
                                    <input
                                      className="ccd-addr-input ccd-addr-input--no-icon"
                                      placeholder="Nearby landmark"
                                      value={landmark}
                                      onChange={(e) => {
                                        setLandmark(e.target.value);
                                        setSelectedSavedAddressId(null);
                                        setValidationErrorMessage((prev) => ({
                                          ...prev,
                                          landmark: "",
                                        }));
                                      }}
                                      disabled={!isAddressEnabled}
                                    />
                                  </div>
                                  {validationErrorMessage?.landmark && (
                                    <span className="ccd-addr-error">
                                      {validationErrorMessage?.landmark}
                                    </span>
                                  )}
                                </div>

                                <div className="ccd-addr-inputs-row">
                                  <div className="ccd-addr-input-group">
                                    <label className="ccd-addr-input-label">City</label>
                                    <div className="ccd-addr-input-wrap">
                                      <input
                                        className="ccd-addr-input ccd-addr-input--no-icon"
                                        placeholder="City"
                                        value={city}
                                        onChange={(e) => {
                                          setCity(e.target.value);
                                          setSelectedSavedAddressId(null);
                                          setValidationErrorMessage((prev) => ({
                                            ...prev,
                                            city: "",
                                          }));
                                        }}
                                        disabled={!isAddressEnabled}
                                      />
                                    </div>
                                    {validationErrorMessage?.city && (
                                      <span className="ccd-addr-error">
                                        {validationErrorMessage?.city}
                                      </span>
                                    )}
                                  </div>
                                  <div className="ccd-addr-input-group">
                                    <label className="ccd-addr-input-label">State</label>
                                    <div className="ccd-addr-input-wrap">
                                      <input
                                        className="ccd-addr-input ccd-addr-input--no-icon"
                                        placeholder="State"
                                        value={state}
                                        onChange={(e) => {
                                          setState(e.target.value);
                                          setSelectedSavedAddressId(null);
                                          setValidationErrorMessage((prev) => ({
                                            ...prev,
                                            state: "",
                                          }));
                                        }}
                                        disabled={!isAddressEnabled}
                                      />
                                    </div>
                                    {validationErrorMessage?.state && (
                                      <span className="ccd-addr-error">
                                        {validationErrorMessage?.state}
                                      </span>
                                    )}
                                  </div>
                                </div>

                                <div className="ccd-addr-inputs-row">
                                  <div className="ccd-addr-input-group">
                                    <label className="ccd-addr-input-label">Postcode</label>
                                    <div className="ccd-addr-input-wrap">
                                      <input
                                        className="ccd-addr-input ccd-addr-input--no-icon"
                                        placeholder="Postcode"
                                        value={postcode}
                                        onChange={(e) => {
                                          const val = e.target.value.replace(/\D/g, "");
                                          if (val?.length <= 6) {
                                            setPostcode(val);
                                            setSelectedSavedAddressId(null);
                                            setValidationErrorMessage((prev) => ({
                                              ...prev,
                                              postcode: "",
                                            }));
                                          }
                                        }}
                                        disabled={!isAddressEnabled}
                                      />
                                    </div>
                                    {validationErrorMessage?.postcode && (
                                      <span className="ccd-addr-error">
                                        {validationErrorMessage?.postcode}
                                      </span>
                                    )}
                                  </div>
                                  <div className="ccd-addr-input-group">
                                    <label className="ccd-addr-input-label">Country</label>
                                    <div className="ccd-addr-input-wrap">
                                      <input
                                        className="ccd-addr-input ccd-addr-input--no-icon"
                                        placeholder="Country"
                                        value={country}
                                        onChange={(e) => {
                                          setCountry(e.target.value);
                                          setSelectedSavedAddressId(null);
                                        }}
                                        disabled={!isAddressEnabled}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {editingAddressId ? (
                                <div className="ccd-edit-address-actions">
                                  <button
                                    type="button"
                                    className="ccd-edit-address-btn-cancel"
                                    onClick={handleCancelEdit}
                                  >
                                    Cancel
                                  </button>
                                  <button
                                    type="button"
                                    className="ccd-edit-address-btn-update"
                                    onClick={handleUpdateAddressClick}
                                    disabled={updateLoading || !isAddressFormValid()}
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      gap: "8px",
                                    }}
                                  >
                                    {updateLoading ? (
                                      <>
                                        <CircularProgress size={16} color="inherit" />
                                        Updating…
                                      </>
                                    ) : (
                                      "Update"
                                    )}
                                  </button>
                                </div>
                              ) : (
                                <div className="ccd-edit-address-actions">
                                  {savedAddresses?.length > 0 && (
                                    <button
                                      type="button"
                                      className="ccd-edit-address-btn-cancel"
                                      onClick={handleCancelEdit}
                                    >
                                      Cancel
                                    </button>
                                  )}
                                  <button
                                    type="button"
                                    className="ccd-edit-address-btn-update"
                                    onClick={handleSaveAddress}
                                    disabled={saveLoading || !isAddressFormValid()}
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      gap: "8px",
                                      gridColumn: savedAddresses?.length > 0 ? "span 1" : "span 2",
                                    }}
                                  >
                                    {saveLoading ? (
                                      <>
                                        <CircularProgress size={16} color="inherit" />
                                        Saving…
                                      </>
                                    ) : (
                                      "Save Address"
                                    )}
                                  </button>
                                </div>
                              )}
                            </>
                          )}
                        </div>
                      </>
                    )}

                    {/* ── Charges input section ── */}
                    {/* {!editingAddressId && !isAddressFormActive && (
                      <div className="ccd-charges-section">
                        <div className="ccd-charges-row">
                          <div className="ccd-charge-group">
                            <label className="ccd-charge-label">Packing Charges</label>
                            <div className="ccd-charge-input-wrap">
                              <span className="ccd-charge-currency-prefix"></span>
                              <input
                                id="packingCharges"
                                type="text"
                                inputMode="decimal"
                                placeholder="0.00"
                                className="ccd-charge-input"
                                value={packingCharges}
                                onChange={(e) => handleChargeInput(e.target.value, setPackingCharges)}
                              />
                            </div>
                          </div>
                          {isDelivery && (
                            <div className="ccd-charge-group">
                              <label className="ccd-charge-label">Delivery Charges</label>
                              <div className="ccd-charge-input-wrap">
                                <span className="ccd-charge-currency-prefix"></span>
                                <input
                                  id="deliveryCharge"
                                  type="text"
                                  inputMode="decimal"
                                  placeholder="0.00"
                                  className="ccd-charge-input"
                                  value={deliveryCharges}
                                  onChange={(e) => handleChargeInput(e.target.value, setDeliveryCharges)}
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    )} */}
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* ── INSIGHTS SIDE (Right Column) ── */}
          <div className="ccd-insights-side-ref">
            <div className="ccd-insights-content-ref">
              <p className="ccd-insights-title-ref">Customer insights</p>
              {!isValidMobile ? (
                /* Empty state */
                <div className="ccd-insights-empty-card-ref">
                  <div className="ccd-insights-empty-icon-ref">
                    <UserIcon />
                  </div>
                  <p className="ccd-insights-empty-title-ref">Waiting for customer details</p>
                  <p className="ccd-insights-empty-sub-ref">
                    Add a mobile number and name to continue with the selected order flow.
                  </p>
                </div>
              ) : (
                <>
                  <div className="ccd-insights-card-ref">
                    <div className="ccd-insights-card-header-ref">
                      <div>
                        <p className="ccd-insights-card-name-ref">{name || "—"}</p>
                        <p className="ccd-insights-card-mobile-ref">
                          {selectedCountry?.value} {phone}
                        </p>
                      </div>
                      <div className="ccd-insights-card-badge-ref">
                        {(() => {
                          const created =
                            foundCustomer?.createdAt ||
                            foundCustomer?.updatedAt ||
                            foundCustomer?.created;
                          return created ? moment(created).format("MMM YYYY") : "New User";
                        })()}
                      </div>
                    </div>
                    <div className="ccd-insights-card-option-ref">
                      <p className="ccd-insights-card-option-label-ref">Order option</p>
                      <p className="ccd-insights-card-option-val-ref">
                        {isDelivery ? "Delivery" : "Take Away"}
                      </p>
                    </div>
                  </div>

                  <div className="ccd-insights-grid-ref">
                    <div className="ccd-insights-tile-ref">
                      <p className="ccd-insights-tile-label-ref">Total orders</p>
                      <p className="ccd-insights-tile-val-ref">
                        {tilesLoading ? (
                          <InsightSpinner />
                        ) : (
                          formatInsightCount(insights?.totalOrders)
                        )}
                      </p>
                    </div>
                    <div className="ccd-insights-tile-ref">
                      <p className="ccd-insights-tile-label-ref">Loyalty points</p>
                      <p className="ccd-insights-tile-val-ref">
                        {tilesLoading ? (
                          <InsightSpinner />
                        ) : (
                          formatInsightCount(insights?.loyaltyPoints)
                        )}
                      </p>
                    </div>
                    <div className="ccd-insights-tile-ref">
                      <p className="ccd-insights-tile-label-ref">Wallet Balance</p>
                      <div className="ccd-insights-tile-val-ref">
                        {tilesLoading ? (
                          <InsightSpinner />
                        ) : (
                          <>
                            <WalletIcon />
                            <span>{formatInsightCurrency(insights?.walletBalance)}</span>
                          </>
                        )}
                      </div>
                    </div>
                    <div className="ccd-insights-tile-ref">
                      <p className="ccd-insights-tile-label-ref">Average basket</p>
                      <p className="ccd-insights-tile-val-ref">
                        {tilesLoading ? (
                          <InsightSpinner />
                        ) : (
                          formatInsightCurrency(insights?.averageBasket)
                        )}
                      </p>
                    </div>
                  </div>

                  <div className="ccd-insights-last-ref">
                    <p className="ccd-insights-last-label-ref">Last ordered</p>
                    <p className="ccd-insights-last-val-ref">
                      {tilesLoading ? (
                        <InsightSpinner small />
                      ) : (
                        formatInsightDate(insights?.lastOrderedAt)
                      )}
                    </p>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>

        {/* Sticky footer placed at bottom of the modal */}
        {!editingAddressId && (
          <div className="ccd-footer-ref">
            <div className="ccd-footer-inner-ref">
              <button
                className="ccd-btn-skip-ref"
                type="button"
                onClick={handleSkip}
                disabled={skipLoading || confirmLoading}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                }}
              >
                {skipLoading ? (
                  <>
                    <CircularProgress size={16} color="inherit" />
                    Skip
                  </>
                ) : (
                  "Skip"
                )}
              </button>
              <button
                className={`ccd-btn-add-ref${
                  isValidMobile && isConfirmButtonVisuallyDisabled ? " visual-disabled" : ""
                }`}
                type="button"
                disabled={
                  (selectedCountry?.value === "+91" && phone?.length !== 10) ||
                  isAddressFormActive ||
                  skipLoading ||
                  confirmLoading
                }
                onClick={() => {
                  if (isDelivery && savedAddresses?.length > 0 && !selectedSavedAddressId) {
                    showSnackbar("Please select an address or Add Address", "warning");
                    return;
                  }
                  handleConfirm();
                }}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                }}
              >
                {confirmLoading ? (
                  <CircularProgress size={16} sx={{ color: "#fff" }} />
                ) : !isValidMobile ? (
                  "Add"
                ) : foundCustomer ? (
                  "Select Customer"
                ) : (
                  "Add Customer"
                )}
              </button>
            </div>
          </div>
        )}
      </Box>
    </Modal>
  );
};

export default TakeawayDeliveryModal;
